export const TEST_ID = 'createBoundaryForm';

export const APPLICATION_FIELD_NAME = 'application';
